import { render, staticRenderFns } from "./IconInTaxReturn.vue?vue&type=template&id=88805892"
import script from "./IconInTaxReturn.vue?vue&type=script&lang=js"
export * from "./IconInTaxReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88805892')) {
      api.createRecord('88805892', component.options)
    } else {
      api.reload('88805892', component.options)
    }
    module.hot.accept("./IconInTaxReturn.vue?vue&type=template&id=88805892", function () {
      api.rerender('88805892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/IconInTaxReturn.vue"
export default component.exports